import { atom } from 'recoil';
export const quizState = atom({
    key: 'take-quiz-state',
    default: {
        isLoading: true,
        answers: [],
        modalSuccess: false,
        percent: 0.0,
        correctAnswers: 0,
        checkResults: false,
        data: null,
        attempts: 0,
        currentAttempt: null,
        KVBucks: 0,
        KVBucksFirstAttempt: 0,
        totalQuestionsAnswered: 0
    }
});
